import { mapValues, forEach } from "./lodash";
import { langList, _langList } from "../const/lang";
import { setCookie, getCookiePair } from "./cookie";
import { DEFAULT_LANG, DEFAULT_COOKIE_KEY, PANDA_I18N_PACK } from "../const";
import { debugInfo, isDebugConsole } from "./log";
export * from "./log";

/** 获取当前环境os的lang */
export var getOSLang = function getOSLang() {
  var _GATEWAY_PF, _GATEWAY_PF$userPrefe;
  return (_GATEWAY_PF = window._GATEWAY_PF) === null || _GATEWAY_PF === void 0 ? void 0 : (_GATEWAY_PF$userPrefe = _GATEWAY_PF.userPreference) === null || _GATEWAY_PF$userPrefe === void 0 ? void 0 : _GATEWAY_PF$userPrefe.lang;
};

/**
 * 语种格式转换：en-US，en_US, en_us, en 全部格式化为en-US
 * @param {string} locale 语种
 */
export var formatLang = function formatLang(locale) {
  // 如果格式不正确直接返回当前的语种防止处理报错
  if (typeof locale !== 'string') {
    return getCurrentLang();
  }
  //  先匹配一轮, 先转成小写，并且将_转成-,然后进行匹配
  var _locale = locale.replace('_', '-');
  if (_locale.includes('-')) {
    _locale = _locale.split('-').map(function (item, index) {
      return index === 1 ? item.toUpperCase() : item;
    }).join('-');
  }
  var _slocale = _locale.toLowerCase();
  var theLang = _langList.find(function (item) {
    return item.value === _locale || (typeof item.s === 'string' ? item.s === _slocale : item.s.includes(_slocale));
  });
  if (theLang) {
    return theLang.value;
  }
  // 处理特殊的 zh-Hans 和 zh-Hant
  if (locale.startsWith('zh-Hans')) {
    return 'zh-CN';
  }
  if (locale.startsWith('zh-Hant')) {
    return locale === 'zh-Hant-TW' ? 'zh-TW' : 'zh-HK';
  }
  // 处理 en-
  if (locale.startsWith('en-')) {
    return 'en-US';
  }
  return locale;
};

/**
 * 获取当前的环境语种的值
 */
export var getCurrentLang = function getCurrentLang() {
  var _window$__PANDA, _window$__PANDA2, _window$__PANDA3, _window$__PANDA6, _window$__PANDA6$lang, _window$__PANDA7;
  var cookieKey = ((_window$__PANDA = window.__PANDA) === null || _window$__PANDA === void 0 ? void 0 : _window$__PANDA.cookieKey) || DEFAULT_COOKIE_KEY;
  // window环境语种
  var envLang = window.__PANDA_LANG;
  var searchLang = (_window$__PANDA2 = window.__PANDA) === null || _window$__PANDA2 === void 0 ? void 0 : _window$__PANDA2.searchLang;
  var osLang = getOSLang();
  // 获取CDN给予的cookieKey, 如果没有默认走x-hng
  var isXhrg = cookieKey === DEFAULT_COOKIE_KEY;
  var customLang = !isXhrg ? getCookiePair(cookieKey)[0] : undefined;
  // eslint-disable-next-line prefer-const
  var _ref = isXhrg ? getXhngCookieLang() : [undefined, false],
    xhngLang = _ref[0],
    hasDomain = _ref[1];
  var defaultLang = (_window$__PANDA3 = window.__PANDA) === null || _window$__PANDA3 === void 0 ? void 0 : _window$__PANDA3.defaultLang;
  // 当x-hng冲突时（存在多个的情况） 提升localLang的权重，用于xhnglang的判断
  if (xhngLang && !hasDomain) {
    var _document$cookie, _document$cookie$matc, _window$__PANDA4;
    if ((((_document$cookie = document.cookie) === null || _document$cookie === void 0 ? void 0 : (_document$cookie$matc = _document$cookie.match(/x-hng/g)) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.length) || 0) > 1 && (_window$__PANDA4 = window.__PANDA) !== null && _window$__PANDA4 !== void 0 && _window$__PANDA4.localLang) {
      var _window$__PANDA5;
      var localLang = (_window$__PANDA5 = window.__PANDA) === null || _window$__PANDA5 === void 0 ? void 0 : _window$__PANDA5.localLang;
      xhngLang = localLang;
    }
  }
  isDebugConsole() && debugInfo("envLang " + envLang + " || searchLang: " + searchLang + " || osLang: " + osLang + " || customLang: " + customLang + " || xhngLang: " + xhngLang + " || defaultLang: " + defaultLang);
  var usedLang = envLang || searchLang || osLang || customLang || xhngLang || defaultLang || DEFAULT_LANG;
  usedLang = formatLang(usedLang);
  // 如果全局设置的langList（允许语种），则最终会受限制
  if ((_window$__PANDA6 = window.__PANDA) !== null && _window$__PANDA6 !== void 0 && (_window$__PANDA6$lang = _window$__PANDA6.langList) !== null && _window$__PANDA6$lang !== void 0 && _window$__PANDA6$lang.length && !((_window$__PANDA7 = window.__PANDA) !== null && _window$__PANDA7 !== void 0 && _window$__PANDA7.langList.includes(usedLang))) {
    usedLang = window.__PANDA.langList[0];
  }
  // 将最新的状态放置到全局变量上用于排查问题
  window.__PANDA.lang = usedLang;
  return usedLang;
};
export function getRandomKey() {
  return Math.random().toString(36).slice(2);
}
export function inLang(lang) {
  return !!langList.find(function (item) {
    return item.value === lang;
  });
}
export function convertPandaI18nFormatToLocalResource(pandaString) {
  var pandaFormat = {};
  forEach(pandaString, function (v, k) {
    pandaFormat[formatLang(k)] = mapValues(v.copyList, function (item) {
      return item.content;
    });
  });
  return pandaFormat;
}

/** 如果非x-hng则设置值，x-hng只处理lang部分 */
export function setCookieLang(lang) {
  if (window.__PANDA.cookieKey === DEFAULT_COOKIE_KEY) {
    var xhngValue = getCookiePair(DEFAULT_COOKIE_KEY)[0];
    if (!xhngValue) {
      setCookie(DEFAULT_COOKIE_KEY, "lang=" + lang + "&domain=" + location.hostname);
    } else {
      var newUrlP = new URLSearchParams();
      new URLSearchParams(xhngValue).forEach(function (v, k) {
        if (k === 'lang') {
          newUrlP.set(k, lang);
        } else {
          newUrlP.set(k, v);
        }
      });
      newUrlP.set('domain', location.hostname);
      setCookie(DEFAULT_COOKIE_KEY, newUrlP.toString());
    }
  } else {
    setCookie(window.__PANDA.cookieKey, lang);
  }
}

/** 如果非x-hng则返回值，x-hng则返回lang部分的值, 实际可能会返回null */
export function getXhngCookieLang() {
  var pairs = getCookiePair(DEFAULT_COOKIE_KEY);
  return [new URLSearchParams(pairs[0]).get('lang'), pairs[1]];
}
export function getNavigatorLang() {
  if (typeof navigator !== 'undefined' && navigator.language && navigator.userAgent) {
    var navigatorLanguage = navigator.language;
    // Compatible with dingding
    if (navigator.userAgent.includes('DingTalk')) {
      var lanuageMatch = navigator.userAgent.match(/language\/([a-zA-Z-]+)/);
      if (lanuageMatch && lanuageMatch !== null && lanuageMatch !== void 0 && lanuageMatch[1]) {
        navigatorLanguage = lanuageMatch[1];
      }
    }
    if (inLang(formatLang(navigatorLanguage))) {
      return formatLang(navigatorLanguage);
    }
    return navigator.languages.find(function (_lang) {
      return inLang(_lang);
    }) || DEFAULT_LANG;
  }
  return DEFAULT_LANG;
}
export function langToShortLang(lang) {
  var theLang = _langList.find(function (item) {
    return item.value === lang;
  });
  if (theLang) {
    return typeof theLang.s === 'string' ? theLang.s : theLang.s[0];
  }
  return lang.split('-')[0].toLocaleLowerCase();
}

// cdn 语言包设置的cookieKey 存在多个语言包挂载的cookieKey不同的情况, 当前按第一个设置为准
/** 通过当前的挂载的语言包的情况设置cookieKey */
export function setCookieKey() {
  if (window[PANDA_I18N_PACK] && Object.keys(window[PANDA_I18N_PACK]).length) {
    var langCookieName = Object.values(window[PANDA_I18N_PACK])[0].langCookieName;
    if (langCookieName && window.__PANDA.cookieKey === DEFAULT_COOKIE_KEY) {
      window.__PANDA.cookieKey = langCookieName;
    }
  }
}

/** 强制设置环境语种，使用window环境变量作为当前window域的语种，优先级高，请勿随意使用！ */
export function setEnvLang(lang) {
  window.__PANDA_LANG = lang;
}